import React from 'react';

import CPQuoteList from 'components/Tvendo/Sale/QuotaBPartner/CPQuote/List.js';

export default function () {
  return <CPQuoteList />;
}
